import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, ArrowLeft, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.add("design-a");
    if (localStorage.getItem("pbd_admin_token")) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/admin/login", { password });
      localStorage.setItem("pbd_admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="design-a min-h-screen flex items-center justify-center px-6 stars-bg">
      <form
        onSubmit={submit}
        className="relative bg-[#0a1628] gold-border p-10 max-w-md w-full"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2 mb-4">
          <ShieldCheck size={16} className="text-[#ffd700]" />
          <span className="font-accent text-[10px] tracking-[0.3em] text-[#ffd700]">
            COMMAND CENTER
          </span>
        </div>
        <h1 className="font-display text-4xl font-black gold-text leading-tight">
          Admin Access
        </h1>
        <p className="mt-2 text-white/60 text-sm">
          Enter the patriot password to inspect the donation vault.
        </p>

        <label className="block mt-7 text-[10px] tracking-[0.3em] uppercase text-white/60">
          Password
        </label>
        <div className="relative mt-2">
          <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#ffd700]" />
          <input
            data-testid="admin-password-input"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className="w-full bg-[#050b14] border border-[#ffd700]/40 text-white placeholder:text-white/30 pl-9 pr-4 py-3 focus:outline-none focus:border-[#ffd700] font-display"
          />
        </div>

        {error && (
          <div
            data-testid="admin-login-error"
            className="mt-4 px-3 py-2 border border-[#b22234] bg-[#b22234]/10 text-[#ff8a99] text-sm"
          >
            {error}
          </div>
        )}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading || !password}
          className="w-full mt-6 bg-gradient-to-b from-[#b22234] to-[#8b1827] hover:from-[#c92a40] text-white font-accent text-[14px] tracking-[0.3em] py-4 border-2 border-[#ffd700] transition-all disabled:opacity-60"
        >
          {loading ? "VERIFYING…" : "ENTER VAULT"}
        </button>

        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 font-accent text-[10px] tracking-[0.3em] text-white/50 hover:text-[#ffd700]"
        >
          <ArrowLeft size={12} /> Back to the Drive
        </Link>
      </form>
    </div>
  );
}
